import { useAppSelector } from '@/hooks/store';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { selectCurrentAccount } from '@/store/features/account';
import { PostHogFeatureFlags } from '@/utils/posthog/posthog.events';

export const usePhishingFollowUpEnabled = () => {
  const { canUseFeature } = useFeatureFlag();
  const account = useAppSelector(selectCurrentAccount);

  const enabled =
    canUseFeature(PostHogFeatureFlags.PHISHING_SIMULATION_FOLLOW_UP) &&
    !!account?.settings?.phishingFollowUpEnabled;

  return { enabled, account };
};
